// extracted by mini-css-extract-plugin
export default {"address":"style_address__AYc4j","address1":"style_address1__xVtc8","address2":"style_address2__1OZb+","city":"style_city__+LVOw","zip":"style_zip__MDpWT"};